import React from "react";
import { useTranslate } from "../../../../components/TranslationText";
import { ServiceEventNames, ServiceActionTypes, HorseGender } from '../../shared/utils/ServicesConstants';
import { LeaseFieldNames } from '../utils/HorseLeasingConstants';
import { TranslationKeys } from '../../../../constants/TranslationKeys';
import EahsForm from "../../../../components/EahsForm";
import FormTextInput from "../../../../components/FormInputs/FormTextInput";

import { useWatch } from "react-hook-form";

const HorseLeasingCommentsSection = ({
    isLessee,
    action
}) => {
    const { translate } = useTranslate();
    const lesseeComment = useWatch({ name: LeaseFieldNames.LESSEE_COMMENT });
    const adminComment = useWatch({ name: LeaseFieldNames.COMMENT });
    const hasComment = !!lesseeComment;
    const hasAdminComment = !!adminComment;

    // Show if user is Lessee OR if there is an existing comment
    const showLesseeComment = isLessee || hasComment;

    return (
        <>
            {hasAdminComment && (
                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.COMMENT, "Comment")}>
                    <div className="col-md-12 col-sm-12 col-12 mb-form-group">
                        <FormTextInput
                            name={LeaseFieldNames.COMMENT}
                            type="textarea"
                            disabled={true}
                        />
                    </div>
                </EahsForm>
            )}

            {showLesseeComment && (
                <EahsForm isSectionTitle className={'mb-main'} ish3 title={translate(TranslationKeys.LESSEE_COMMENT, "Lessee Comment")}>
                    <div className="col-md-12 col-sm-12 col-12 mb-form-group">
                        <FormTextInput
                            name={LeaseFieldNames.LESSEE_COMMENT}
                            type="textarea"
                            disabled={!isLessee || action === ServiceActionTypes.VIEW}
                        />
                    </div>
                </EahsForm>
            )}
        </>
    );
};

export default HorseLeasingCommentsSection;
